<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.p-3(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content
      b-button.mb-3(
        variant="primary",
        @click="createTempTextHandler()"
      )
        i.fas.fa-plus.mr-1
        | 新增訊息模板
      .row.no-gutters
        .col-6.pr-1
          b-button(
            :variant="selectType === 'backend' ? 'primary' : 'outline-primary'",
            block,
            @click="changeTypeHandler('backend')"
          ) 官方帳號建立
        .col-6.pl-1
          b-button(
            :variant="selectType === 'ba' ? 'primary' : 'outline-primary'",
            block,
            @click="changeTypeHandler('ba')"
          ) BA建立
      .mb-2
        template(
          v-for="(temp,index) in temps"
        )
          text-input(
            v-if='temp.push_format.type === "text"',
            :key="temp.id",
            :index='index',
            :originalData="temp",
            :selectMode="true",
            :selectTemps="selectTemps",
            :editMode="temp.type === 'ba'"
            @selectTempHandler="selectTempHandler",
            @editTempHandler="editTempHandler",
            @deleteTempHandler="deleteTempHandler"
          )
          image-map-input(
            v-if='temp.push_format.type === "imageMap"',
            :key="temp.id",
            :index='index',
            :originalData="temp",
            :selectMode="true",
            :selectTemps="selectTemps",
            @selectTempHandler="selectTempHandler"
          )
          carousel-input(
            v-if='temp.push_format.type === "carousel"',
            :key="temp.id",
            :index='index',
            :originalData="temp",
            :selectMode="true",
            :selectTemps="selectTemps",
            @selectTempHandler="selectTempHandler"
          )
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles",
          ref="infiniteLoading"
        )
          .cursor-default.mt-3(slot="no-more") 無更多模板
          .cursor-default.mt-3(slot="no-results") 無更多模板
          .cursor-default.mt-3(slot="error") 發生錯誤，請重整重試一次
    .px-4
      .row.justify-content-center
        .col-6
          button.btn.btn-block.btn-primary(
            type="button",
            @click="previewHandler()"
          ) 發送預覽
    //- 前台模板新增 - 文字
    tempTextModel(
      title="新增訊息模板",
      Zindex='20px',
      :modelCSS="tempModelCSS",
      @scrollToTarget="scrollToTarget",
      @changeTypeHandler="changeTypeHandler"
    )

    //- 發送預覽
    tempSendPreviewModel(
      title="發送訊息預覽",
      Zindex='25px',
      :modelCSS="tempModelCSS",
      :previewTemps="selectTemps",
      :user="user"
      :multicastPush="multicastPush",
      :users="users",
      @scrollToTarget="scrollToTarget",
      @closeModelHandler="closeModel"
    )

</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';
import tempTextModel from '@/components/customerModel/tempTextModel.vue';
import tempSendPreviewModel from '@/components/customerModel/tempSendPreviewModel.vue';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';

const _ = require('lodash');

export default {
  name: 'TempModel',
  components: {
    InfiniteLoading,
    tempTextModel,
    tempSendPreviewModel,
    textInput,
    imageMapInput,
    carouselInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: [Object, null],
      default: null
    },
    multicastPush: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      selectType: 'backend',
      selectTemps: [], // 選擇的模板
      tempModelCSS: {
        top: 0
      }, // 新增訊息模板的 CSS
      infiniteId: +new Date(),
      windowScrollHeight: 0 // 視窗原本位置
    };
  },
  mounted() {
    this.$EventBus.$on('openTempModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      vm.selectTemps = [];
      vm.$store.commit('sa_temp/resetInfiniteLoadingData');

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      let apiTarget;

      switch (vm.selectType) {
        case 'ba':
          apiTarget = 'getTemplatesHandler';
          break;
        case 'backend':
          apiTarget = 'getTemplatesAdminHandler';
          break;
        default:
          break;
      }

      if (!vm.selectType || !apiTarget) {
        vm.$swal.fire({
          icon: 'error',
          title: '編輯目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch(`sa_temp/${apiTarget}`, {
        current_page: parseInt(vm.pagination.current_page) + 1,
        per_page: parseInt(vm.pagination.per_page)
      }).then(() => {
        if (vm.pagination.current_page != vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    // 選擇模板
    selectTempHandler({ id, template }) {
      const vm = this;
      const selectTemps_key = _.findKey(vm.selectTemps, (val) => val.id === id && val.type === template);
      if (selectTemps_key) {
        vm.selectTemps.splice(selectTemps_key, 1);
      } else {
        const temps_key = _.findKey(vm.temps, (val) => val.id === id && val.type === template);
        if (temps_key) {
          vm.selectTemps.push(vm.temps[temps_key]);
        }
      }
    },
    // 編輯模板
    async editTempHandler({ id }) {
      const vm = this;
      const key = _.findKey(vm.temps, (val) => val.id === id);
      if (key && vm.temps[key].push_format.type === 'text') {
        vm.windowScrollHeight = $('#CustomerTempModel').scrollTop();
        await vm.scrollToTop();
        vm.$EventBus.$emit('openTempTextModel', vm.temps[key]);
      }
    },
    // 刪除模板
    deleteTempHandler({ id }) {
      const vm = this;
      vm.$swal.fire({
        title: '您確定刪除訊息模板?',
        text: '刪除後模板無法復原！',
        html: '請注意，刪除後將<span style="color: #d33">無法回覆</span>該訊息模板',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary px-5'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '訊息模板刪除中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          // 解除綁定
          vm.$store.dispatch('sa_temp/deleteTempHandler', id)
            .then(() => {
              const key = _.findKey(vm.selectTemps, (val) => val.id === id);
              vm.selectTemps.splice(vm.selectTemps[key], 1);
              vm.$snotify.success(null, '訊息模板刪除成功');
              vm.changeTypeHandler(vm.selectType);
              vm.$swal.close();
            });
        }
      });
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
    },
    changeTypeHandler(type = this.selectType) {
      const vm = this;
      vm.$store.commit('sa_temp/resetInfiniteLoadingData');
      vm.selectType = type;
      vm.infiniteId += 1;
    },
    // 開啟新增訊息模板彈窗
    async createTempTextHandler() {
      const vm = this;
      vm.windowScrollHeight = $('#CustomerTempModel').scrollTop();
      await vm.scrollToTop();
      vm.$EventBus.$emit('openTempTextModel');
    },
    // 發送預覽
    async previewHandler() {
      const vm = this;
      if (vm.selectTemps.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '至少需要選擇一則模板'
        });
      } else if (vm.selectTemps.length > 5) {
        vm.$swal.fire({
          icon: 'error',
          title: '單次最多只能發送五則訊息'
        });
      } else {
        vm.windowScrollHeight = $('#CustomerTempModel').scrollTop();
        await vm.scrollToTop();
        vm.$EventBus.$emit('openTempSendPreviewModel');
      }
    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve, reject) => {
        if ($('#CustomerTempModel').scrollTop() === 0) {
          resolve();
        } else {
          $('#CustomerTempModel').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    // 把視窗移到原本位置
    scrollToTarget() {
      const vm = this;
      return new Promise((resolve, reject) => {
        $('#CustomerTempModel').animate({
          scrollTop: vm.windowScrollHeight
        }, 500);
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').removeClass('overflow-hidden');
          resolve();
        }, 550);
      });
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openTempModel');
  },
  computed: {
    ...mapState({
      temps: (state) => state.sa_temp.temps,
      pagination: (state) => state.sa_temp.pagination
    })
  }
};
</script>

<style>

</style>
